// extracted by mini-css-extract-plugin
export default {"header__nav-section--full-width":"header__nav-section--full-width_zq3yosmH"};